export default __webpack_public_path__ + "images/d9682255e82169d28400967f94936377-chatbot_stars.svg";